import { HOST_URL, isNewBackend } from 'config';
import SingletonConfig from 'utils/global';
import AjaxUtil from '../../../Js/AjaxHelper/AjaxUtil';
import * as HelpersHeaders from '../../../Js/AjaxHelper/Helpers';
import { logoutMicroservices } from 'pages/auth/hooks/useAuthSass/utils';

const SETTINGS_API = '/WebApp/Settings';
const SETTINGS_API_NEW = '/Settings';
const ACCOUNT_API = '/WebApp/Account';

export default class api {
  static getUserPermissionsGlobal(userId, clientId) {
    let url = `${HOST_URL}/WebAppGlobal/Users/GetUserPermissions`;
    url += `?userId=${userId}`;
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    return AjaxUtil.sendGet(url, headers);
  }
  static changeUserPermissionGlobal(userId, permissions, clientId) {
    let url = `${HOST_URL}/WebAppGlobal/Users/ChangeUserPermission`;
    url += `?userId=${userId}`;
    let body = JSON.stringify({ userId: userId, newUserPermisions: permissions });
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    return AjaxUtil.genericSendPost(url, body, headers);
  }
  static ChangeUserPasswordGlobal(changePassword, clientId) {
    let url = `${HOST_URL}/WebAppGlobal/Users/ChangeUserPassword`;
    let body = JSON.stringify({ changePassword: changePassword });
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    return AjaxUtil.genericSendPost(url, body, headers);
  }
  static ChangeUserEmailGlobal(changeEmail, clientId) {
    const url = `${HOST_URL}/WebAppGlobal/Users/ChangeUserEmail`;
    const body = JSON.stringify({ changeEmail });
    const headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    return AjaxUtil.genericSendPost(url, body, headers);
  }
  static getAllUsers() {
    const url = AjaxUtil.getUrl(SETTINGS_API_NEW + '/GetAllUsers');
    return AjaxUtil.sendGet(url);
  }
  static getAllGlobalUsers(clientId) {
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    const url = `${HOST_URL}/WebAppGlobal/Settings/GetAllUsers`;
    return AjaxUtil.sendGet(url, headers);
  }

  static addUser(user) {
    let url = HOST_URL + SETTINGS_API + '/AddUser';
    return AjaxUtil.genericSendPost(url, JSON.stringify({ user: user }));
  }
  static addUserGlobal(user, clientId) {
    let url = `${HOST_URL}/WebAppGlobal/Users/AddUser`;
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    return AjaxUtil.genericSendPost(url, JSON.stringify({ user: user }), headers);
  }
  static deleteUser(userId) {
    let url = HOST_URL + SETTINGS_API + '/DeleteUser';
    return AjaxUtil.genericSendPost(url, JSON.stringify({ userId: userId }));
  }
  static deleteUserGlobal(userId, clientId) {
    let url = `${HOST_URL}/WebAppGlobal/Users/DeleteUser`;
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    return AjaxUtil.genericSendPost(url, JSON.stringify({ userId: userId }), headers);
  }

  static changeUserPassword(changePassword) {
    const url = AjaxUtil.getUrl(SETTINGS_API_NEW + '/ChangeUserPassword');

    return AjaxUtil.genericSendPost(url, JSON.stringify({ changePassword: changePassword }));
  }

  static changeUserEmail(email) {
    const url = AjaxUtil.getUrl(SETTINGS_API_NEW + '/ChangeUserEmail');

    return AjaxUtil.genericSendPost(url, JSON.stringify({ changeEmail: email }));
  }

  static getUserPermissions(userId) {
    const url = AjaxUtil.getUrl(SETTINGS_API_NEW + `/GetUserPermissions?userId=${userId}`);

    return AjaxUtil.sendGet(url);
  }

  static getMfaStatusByUserId(userId) {
    const url = AjaxUtil.getUrl(SETTINGS_API_NEW + `/GetMfaStatusByUserId?userId=${userId}`);

    return AjaxUtil.sendGet(url);
  }

  static getMfaStatusByUserIdGlobal(userId, clientId) {
    let url = `${HOST_URL}/WebAppGlobal/Settings/GetMfaStatusByUserId`;
    url += `?userId=${userId}`;
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    return AjaxUtil.sendGet(url, headers);
  }

  static isMfaEnabled() {
    const url = `${HOST_URL}/WebApp/Settings/IsMfaEnabled`;
    return AjaxUtil.sendGet(url);
  }

  static isMfaEnabledGlobal(clientId) {
    const url = `${HOST_URL}/WebAppGlobal/Settings/IsMfaEnabled`;
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    return AjaxUtil.sendGet(url, headers);
  }

  static isAddUsernameInEmailFormat() {
    const url = `${HOST_URL}/WebApp/Settings/IsAddUsernameInEmailFormat`;
    return AjaxUtil.sendGet(url);
  }

  static isAddUsernameInEmailFormatGlobal(clientId) {
    const url = `${HOST_URL}/WebAppGlobal/Settings/IsAddUsernameInEmailFormat`;
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    return AjaxUtil.sendGet(url, headers);
  }

  static changeUserPermission(userId, newUserPermisions) {
    const url = AjaxUtil.getUrl(SETTINGS_API_NEW + '/ChangeUserPermission');

    let body = JSON.stringify({ userId: userId, newUserPermisions: newUserPermisions });
    return AjaxUtil.genericSendPost(url, body);
  }

  static changeUserMfaSettings(userId, userMfaAction, phoneNumber) {
    const url = AjaxUtil.getUrl(SETTINGS_API_NEW + '/ChangeUserMfaSettings');
    let body = JSON.stringify({
      user_id: userId,
      user_mfa_action: userMfaAction,
      phone_number: phoneNumber
    });
    return AjaxUtil.genericSendPost(url, body);
  }

  static changeUserMfaSettingsGlobal(userId, userMfaAction, phoneNumber, clientId) {
    const url = `${HOST_URL}/WebAppGlobal/Settings/ChangeUserMfaSettings`;
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    let body = JSON.stringify({
      user_id: userId,
      user_mfa_action: userMfaAction,
      phone_number: phoneNumber
    });
    return AjaxUtil.genericSendPost(url, body, headers);
  }

  static validateUserActivity() {
    const url = HOST_URL + ACCOUNT_API + '/ValidateUserActivity';
    return AjaxUtil.sendGet(url);
  }

  static getUserRoles() {
    let url = `${HOST_URL}/WebApp/Settings/GetUserRolesAsync`;
    if (SingletonConfig.isGlobalMode) {
      url = `${HOST_URL}/WebAppGlobal/Users/GetUserRolesAsync`;
    }
    return AjaxUtil.sendGet(url);
  }

  //TODO:: should delete this
  static getUserRolesGlobal(clientId) {
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    const url = `${HOST_URL}/WebAppGlobal/Users/GetUserRolesAsync`;
    return AjaxUtil.sendGet(url, headers);
  }

  static addUserRole(addUserRoleDTO) {
    let url = `${HOST_URL}/WebApp/Settings/AddUserRoleAsync`;
    return AjaxUtil.genericSendPost(url, JSON.stringify({ addUserRoleDTO: addUserRoleDTO }));
  }

  static addUserRoleGlobal(addUserRoleDTO, clientId) {
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    let url = `${HOST_URL}/WebAppGlobal/Users/AddUserRoleAsync`;
    return AjaxUtil.genericSendPost(url, JSON.stringify({ addUserRoleDTO: addUserRoleDTO }), headers);
  }

  static changeUserRole(userId, userRoleId) {
    let url = `${HOST_URL}/WebApp/Settings/ChangeUserRoleAsync`;
    let body = JSON.stringify({ userId: userId, userRoleId: userRoleId });
    return AjaxUtil.genericSendPost(url, body);
  }

  static changeUserRoleGlobal(userId, userRoleId, clientId) {
    const headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    const url = `${HOST_URL}/WebAppGlobal/Users/ChangeUserRoleAsync`;
    const body = JSON.stringify({ userId: userId, userRoleId: userRoleId });
    return AjaxUtil.genericSendPost(url, body, headers);
  }

  static changeRolePermissions(roleId, newRolePermisions) {
    let url = `${HOST_URL}/WebApp/Settings/ChangeRolePermissionsAsync`;
    let body = JSON.stringify({ roleId: roleId, newRolePermisions: newRolePermisions });
    return AjaxUtil.genericSendPost(url, body);
  }

  static changeRolePermissionsGlobal(roleId, newRolePermisions, clientId) {
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    let url = `${HOST_URL}/WebAppGlobal/Users/ChangeRolePermissionsAsync`;
    let body = JSON.stringify({ roleId: roleId, newRolePermisions: newRolePermisions });
    return AjaxUtil.genericSendPost(url, body, headers);
  }

  static deleteRole(roleId) {
    let url = `${HOST_URL}/WebApp/Settings/DeleteRoleAsync`;
    return AjaxUtil.genericSendPost(url, JSON.stringify({ roleId: roleId }));
  }

  static deleteRoleGlobal(roleId, clientId) {
    let headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    let url = `${HOST_URL}/WebAppGlobal/Users/DeleteRoleAsync`;
    return AjaxUtil.genericSendPost(url, JSON.stringify({ roleId: roleId }), headers);
  }

  static changeRoleSitesGlobal(roleId, sites, clientId) {
    const headers = clientId && HelpersHeaders.GetGlobalHeaders(clientId);
    const url = `${HOST_URL}/WebAppGlobal/Users/ChangeRoleSitesAsync`;
    const body = JSON.stringify({ roleId: roleId, sites: sites });
    return AjaxUtil.genericSendPost(url, body, headers);
  }

  static logout = async reasonCode => {
    if (window.logUserSession) {
      // eslint-disable-next-line no-console
      console.log(`api.logout() was called with reasonCode: ${reasonCode}`);
    }
    const url = `${HOST_URL}/WebApp/Account/LogOut?l=${reasonCode || ''}`;
    if (isNewBackend) {
      try {
        await logoutMicroservices(reasonCode);
      } catch (e) {}
    }
    return AjaxUtil.sendGet(url);
  };
}
